module.exports = __webpack_public_path__ + "static/media/_order_complete.657d2df7.png";